import React from 'react';
import styled from 'styled-components';

interface LicenseLimitModalProps {
  isOpen: boolean;
  message: string;
  onClose: () => void;
  onUpgrade?: () => void; // 선택적 prop으로 변경
  showUpgradeButton?: boolean; // 이용권 구매 버튼 표시 여부 (기본값: true)
}

const LicenseLimitModal: React.FC<LicenseLimitModalProps> = ({
  isOpen,
  message,
  onClose,
  onUpgrade,
  showUpgradeButton = true, // 기본값: true
}) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>이용권 제한</ModalTitle>
          <CloseButton onClick={onClose}>×</CloseButton>
        </ModalHeader>
        <ModalBody>
          <Message>{message}</Message>
        </ModalBody>
        <ModalFooter>
          {showUpgradeButton && onUpgrade && (
            <UpgradeButton onClick={onUpgrade}>
              이용권 구매
            </UpgradeButton>
          )}
          <CloseModalButton onClick={onClose}>
            닫기
          </CloseModalButton>
        </ModalFooter>
      </ModalContent>
    </ModalOverlay>
  );
};

export default LicenseLimitModal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10001;
`;

const ModalContent = styled.div`
  background: var(--color-surface);
  border-radius: 12px;
  padding: 0;
  box-shadow: var(--modal-shadow-large);
  width: 90%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  border: var(--modal-border);
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid var(--color-border);
`;

const ModalTitle = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--color-text-primary);
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 28px;
  color: var(--color-text-secondary);
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background: var(--color-panel);
    color: var(--color-text-primary);
  }
`;

const ModalBody = styled.div`
  padding: 24px;
  flex: 1;
  overflow-y: auto;
`;

const Message = styled.p`
  margin: 0;
  font-size: 1rem;
  line-height: 1.6;
  color: var(--color-text-primary);
  white-space: pre-line;
`;

const ModalFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid var(--color-border);
`;

const UpgradeButton = styled.button`
  width: 100%;
  padding: 14px 24px;
  background: var(--color-accent-strong);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: var(--color-accent);
    transform: translateY(-1px);
    box-shadow: var(--modal-shadow);
  }

  &:active {
    transform: translateY(0);
  }
`;

const CloseModalButton = styled.button`
  width: 100%;
  padding: 12px 24px;
  background: var(--color-panel);
  color: var(--color-text-primary);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: var(--color-border);
  }
`;

